import {
  Tooltip,
  Stack,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Checkbox,
  FormControlLabel,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import RestoreIcon from "@mui/icons-material/Restore";
import IconButton from "@mui/material/IconButton";
// Imports from common components
import CommonAgGrid from "./common/CommonAgGrid/CommonAgGrid";
import CustomAccordion from "./common/CustomAccordion";
import { apiFetch } from "../utils/auth";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import { CustomTooltipCell } from "./common/CustomTooltip";
import BackgroundContainer from "./common/BackgroundContainer";
import { mergeLMPByHourEnding } from "../utils";
import CustomDatePicker from "altopenergy.customdatepicker";

const ERCOT = () => {
  const formatTimestamp = (timestamp) => {
    // If the timestamp is already in HH:MM format, return it as is
    if (/^\d{2}:\d{2}$/.test(timestamp)) {
      return timestamp;
    }

    // Otherwise, format it into HH:MM
    const date = new Date(timestamp);
    return `${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
  };
  const isValidNumber = (v) => !Number.isNaN(Number(v));
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const red = theme.palette.customColors.pnlRed;
  const green = theme.palette.customColors.pnlGreen;
  // States
  const [countdown, setCountdown] = useState(15);
  const [CurrentTime, setCurrentTime] = useState("");

  const [DALMP, setDALMP] = useState([]);
  const [DALMP_AVG, setDALMP_AVG] = useState("");
  const [DALMP_ColumnDefs, setDALMP_ColumnDefs] = useState([
    { field: "HE", headerName: "HE", flex: 1 },
    { field: "LMP", headerName: "LMP", flex: 1 },
  ]);
  const [DayAheadRowData, setDayAheadRowData] = useState([]);

  const [DAClass, setDAClass] = useState("OnPeak");
  const [CustomModifiedRows, setCustomModifiedRows] = useState([]);
  const [Hybrid, setHybrid] = useState([]);
  const [Hybrid_ColumnDefs, setHybrid_ColumnDefs] = useState([
    { field: "LMP", headerName: "LMP", flex: 1 },
    {
      field: "Ticks",
      headerName: "Ticks",
      flex: 1,
      cellRenderer: (params) => {
        const rtlmp = params.value;
        const row = params.data;

        const tableData = row.AdditionalData;

        return (
          <CustomTooltipCell
            tooltipContent={
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Interval</TableCell>
                      <TableCell>LMP</TableCell>
                      <TableCell>SCED</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((row, index) => {
                      console.log(row);

                      const { Interval, IntervalLMP, ScedTimestamp } = row;
                      const rowCount = ScedTimestamp.length;

                      return ScedTimestamp.map((timestamp, timestampIndex) => (
                        <TableRow key={`${index}-${timestampIndex}`}>
                          {timestampIndex === 0 ? (
                            <>
                              <TableCell rowSpan={rowCount}>
                                {Interval}
                              </TableCell>
                              <TableCell rowSpan={rowCount}>
                                {IntervalLMP}
                              </TableCell>
                            </>
                          ) : null}
                          <TableCell>{formatTimestamp(timestamp)}</TableCell>
                        </TableRow>
                      ));
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            }
            value={<Box>{Math.round(rtlmp * 10) / 10}</Box>}
          />
        );
      },
    },
  ]);
  const [Custom, setCustom] = useState([]);
  const [Custom_ColumnDefs, setCustom_ColumnDefs] = useState([
    {
      field: "LMP",
      headerName: "LMP",
      flex: 1,
      editable: (params) => {
        const he = params.data.HourEnding;

        // Rule 1: Hybrid mode + current HE → disable
        if (useDAHybrid && he === currentHE) return false;

        // Rule 2: Disable for past hours
        if (he < currentHE) return false;

        // Otherwise editable
        return true;
      },
    },
    {
      field: "Ticks",
      headerName: "Ticks",
      flex: 1,
      cellRenderer: (params) => {
        const rtlmp = params.value;
        const row = params.data;
        const tableData = row.AdditionalData;
        return (
          <CustomTooltipCell
            tooltipContent={
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Interval</TableCell>
                      <TableCell>LMP</TableCell>
                      <TableCell>SCED</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((row, index) => {
                      const { Interval, IntervalLMP, ScedTimestamp } = row;
                      const rowCount = ScedTimestamp.length;

                      return ScedTimestamp.map((timestamp, timestampIndex) => (
                        <TableRow key={`${index}-${timestampIndex}`}>
                          {timestampIndex === 0 ? (
                            <>
                              <TableCell rowSpan={rowCount}>
                                {Interval}
                              </TableCell>
                              <TableCell rowSpan={rowCount}>
                                {IntervalLMP}
                              </TableCell>
                            </>
                          ) : null}
                          <TableCell>{formatTimestamp(timestamp)}</TableCell>
                        </TableRow>
                      ));
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            }
            value={<Box>{Math.round(rtlmp * 10) / 10}</Box>}
          />
        );
      },
    },
  ]);

  const [Hybrid_AVG, setHybrid_AVG] = useState("");
  const [HybridRowData, setHybridRowData] = useState([]);

  const [ERCOTRucData, setERCOTRucData] = useState([]);
  const [ERCOTFrequency, setERCOTFrequency] = useState("");
  const [ERCOTFrequencyDelta, setERCOTFrequencyDelta] = useState("");
  const [SCEDData, setSCEDData] = useState([]);
  const [SCED_ColumnDefs, setSCED_ColumnDefs] = useState([
    {
      field: "ScedTimeStampCst",
      headerName: "Timestamp",
      flex: 1,
      cellStyle: (params) => ({
        fontSize: "16px",
      }),
    },
    {
      field: "SCED",
      headerName: "SCED",
      flex: 1,
      cellStyle: (params) => ({
        fontSize: "16px",
      }),
    },
  ]);
  const [IndicativePrices, setIndicativePrices] = useState([]);
  const [IndicativePrices_ColumnDefs, setIndicativePrices_CoulmnDefs] =
    useState([
      {
        field: "Interval",
        headerName: "Interval",
        flex: !isMobile && 1,
        width: isMobile && 115,
        cellStyle: (params) => ({
          fontSize: "14px",
        }),
      },
      {
        field: "SCED",
        headerName: "SCED",
        flex: !isMobile && 1,
        width: isMobile && 100,
        cellStyle: (params) => ({
          fontSize: "14px",
        }),
      },
      {
        field: "Indicative",
        headerName: "Indicative",
        flex: !isMobile && 1.125,
        width: isMobile && 125,
        cellStyle: (params) => {
          // Get the previous row value for the comparison
          const previousRow = params.api.getDisplayedRowAtIndex(
            params.rowIndex + 1,
          );
          const previousLMP = previousRow ? previousRow.data.Indicative : null;
          const currentLMP = params.value;

          // Compare current row value with previous row's value for LMP
          if (previousLMP !== null) {
            // Convert to numbers to ensure we are comparing numbers, not strings
            const currentLMPNum = Number(currentLMP);
            const previousLMPNum = Number(previousLMP);

            // Check if both values are valid numbers before proceeding
            if (!isNaN(currentLMPNum) && !isNaN(previousLMPNum)) {
              if (currentLMPNum < previousLMPNum) {
                return {
                  color: "#FF0000",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "#2a2a2a",
                  fontSize: "14px",
                }; // If current < previous, color red
              } else if (currentLMPNum > previousLMPNum) {
                return {
                  color: "#30bf35",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "#2a2a2a",
                  fontSize: "14px",
                }; // If current > previous, color green
              }
            }
          }

          return {}; // No style if no previous value to compare
        },
      },
      {
        field: "Prev01",
        headerName: "Prev01",
        flex: !isMobile && 1,
        width: isMobile && 120,
        cellStyle: (params) => {
          // Get the previous row value for the comparison
          const previousRow = params.api.getDisplayedRowAtIndex(
            params.rowIndex + 1,
          );
          const previousLMP = previousRow ? previousRow.data.Prev01 : null;
          const currentLMP = params.value;

          // Compare current row value with previous row's value for LMP
          if (previousLMP !== null) {
            // Convert to numbers to ensure we are comparing numbers, not strings
            const currentLMPNum = Number(currentLMP);
            const previousLMPNum = Number(previousLMP);

            // Check if both values are valid numbers before proceeding
            if (!isNaN(currentLMPNum) && !isNaN(previousLMPNum)) {
              if (currentLMPNum < previousLMPNum) {
                return {
                  color: "#FF0000",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "none",
                }; // If current < previous, color red
              } else if (currentLMPNum > previousLMPNum) {
                return {
                  color: "#30bf35",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "none",
                }; // If current > previous, color green
              }
            }
          }

          return {}; // No style if no previous value to compare
        },
      },
      {
        field: "Prev02",
        headerName: "Prev02",
        flex: !isMobile && 1,
        width: isMobile && 120,
        cellStyle: (params) => {
          // Get the previous row value for the comparison
          const previousRow = params.api.getDisplayedRowAtIndex(
            params.rowIndex + 1,
          );
          const previousLMP = previousRow ? previousRow.data.Prev02 : null;
          const currentLMP = params.value;

          // Compare current row value with previous row's value for LMP
          if (previousLMP !== null) {
            // Convert to numbers to ensure we are comparing numbers, not strings
            const currentLMPNum = Number(currentLMP);
            const previousLMPNum = Number(previousLMP);

            // Check if both values are valid numbers before proceeding
            if (!isNaN(currentLMPNum) && !isNaN(previousLMPNum)) {
              if (currentLMPNum < previousLMPNum) {
                return {
                  color: "#FF0000",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "none",
                }; // If current < previous, color red
              } else if (currentLMPNum > previousLMPNum) {
                return {
                  color: "#30bf35",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "none",
                }; // If current > previous, color green
              }
            }
          }

          return { fontSize: "14px" }; // No style if no previous value to compare
        },
      },
    ]);
  const [Ruc_ColumnDefs, setRuc_ColumnDefs] = useState([
    {
      field: "HE",
      headerName: "HE",
      flex: !isMobile && 1,
      width: isMobile && 120,
    },
    {
      field: "Houston",
      headerName: "Houston",
      flex: !isMobile && 1,
      width: isMobile && 120,
    },
    {
      field: "North",
      headerName: "North",
      flex: !isMobile && 1,
      width: isMobile && 120,
    },
    {
      field: "South",
      headerName: "South",
      flex: !isMobile && 1,
      width: isMobile && 120,
    },
    {
      field: "West",
      headerName: "West",
      flex: !isMobile && 1,
      width: isMobile && 120,
    },
  ]);
  const [LatestRucMarketDay, setLatestRucMarketDay] = useState("");
  const [LatestIndicativeTimestamp, setLatestIndicativeTimestamp] =
    useState("");

  const [LatestFrequencyTimestamp, setLatestFrequencyTimestamp] = useState(0);
  const [flowDate, setflowDate] = useState(dayjs());
  const [useIndicative, setuseIndicative] = useState(true);
  const [useDAHybrid, setuseDAHybrid] = useState(true);
  const [currentHE, setcurrentHE] = useState("");
  const [DAHybrid, setDAHybrid] = useState("");
  const [SCEDAvg, setSCEDAvg] = useState("");
  const previousFrequencyRef = useRef(0); // This will store the previous frequency value
  const dateRef = useRef();
  //  Api Calls

  const funcFetchDALMP = (shouldTrack) => {
    apiFetch("balday/getTopTables", {
      method: "POST",
      body: JSON.stringify({
        ISO: "ERCOT",
        FlowDate: dateRef.current || flowDate.format("YYYY-MM-DD"),
      }),
      track: shouldTrack,
    })
      .then((res) => res.json())
      .then((res) => {
        setDALMP(res.DALMP);
        setDALMP_AVG(res.DALMP_AVG);
        setHybrid(res.Hybrid);

        setDAHybrid(res.DAHybridValue);
        setcurrentHE(res.CurrentHourEnding);

        setERCOTRucData(res.ERCOTRucData);
        setLatestFrequencyTimestamp(res.LatestERCOTFrequencyTimestamp);

        setERCOTFrequency(res.LatestERCOTFrequency);
        setSCEDData(res.SCEDData);
        setIndicativePrices(res.ERCOTIndicativePrices);
        setLatestRucMarketDay(res.ERCOTRucLatestMarketDay);
        setLatestIndicativeTimestamp(res.LatestIndicativeTimestamp);

        setSCEDAvg(res.SCEDAvg);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const funcFilterCustom = (shouldTrack) => {
    apiFetch("balday/modifyCustom", {
      method: "POST",
      body: JSON.stringify({
        Custom: Hybrid,
        IndicativePrices: IndicativePrices,
        ISO: "ERCOT",
      }),
      track: shouldTrack,
    })
      .then((res) => res.json())
      .then((res) => {
        setCustom(
          mergeLMPByHourEnding(res.Custom, CustomModifiedRows, currentHE),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    // Calculate the delta when ERCOTFrequency changes
    const delta = ERCOTFrequency - previousFrequencyRef.current;
    setERCOTFrequencyDelta(delta.toFixed(3));

    // Update the previous frequency reference to the current frequency
    previousFrequencyRef.current = ERCOTFrequency;
  }, [ERCOTFrequency]);

  useEffect(() => {
    if (!DALMP) return;

    if (DAClass === "OnPeak") {
      const updatedData = DALMP.filter((row) => row.OnPeak);
      const meanLMP = (
        updatedData.reduce((sum, row) => sum + row.LMP, 0) / updatedData.length
      ).toFixed(2);
      setDayAheadRowData(DALMP.filter((row) => row.OnPeak));
      setDALMP_AVG(meanLMP);
    } else if (DAClass === "OffPeak") {
      const updatedData = DALMP.filter((row) => !row.OnPeak);
      const meanLMP = (
        updatedData.reduce((sum, row) => sum + row.LMP, 0) / updatedData.length
      ).toFixed(2);
      setDayAheadRowData(DALMP.filter((row) => !row.OnPeak));
      setDALMP_AVG(meanLMP);
    } else if (DAClass === "WePeak") {
      const updatedData = DALMP.filter((row) => row.WePeak);
      const meanLMP = (
        updatedData.reduce((sum, row) => sum + row.LMP, 0) / updatedData.length
      ).toFixed(2);
      setDayAheadRowData(DALMP.filter((row) => row.WePeak));
      setDALMP_AVG(meanLMP);
    } else {
      const meanLMP = (
        DALMP.reduce((sum, row) => sum + row.LMP, 0) / DALMP.length
      ).toFixed(2);
      setDayAheadRowData(DALMP);
      setDALMP_AVG(meanLMP);
    }
  }, [DALMP, DAClass]);

  useEffect(() => {
    if (!Hybrid) return;

    if (DAClass === "OnPeak") {
      const updatedData = Hybrid.filter((row) => row.OnPeak);
      setHybridRowData(updatedData);
      setHybrid_AVG(
        (
          updatedData.reduce((sum, row) => sum + row.LMP, 0) /
          updatedData.length
        ).toFixed(2),
      );
    } else if (DAClass === "OffPeak") {
      const updatedData = Hybrid.filter((row) => !row.OnPeak);
      setHybridRowData(updatedData);
      setHybrid_AVG(
        (
          updatedData.reduce((sum, row) => sum + row.LMP, 0) /
          updatedData.length
        ).toFixed(2),
      );
    } else if (DAClass === "WePeak") {
      const updatedData = Hybrid.filter((row) => row.WePeak);
      setHybridRowData(updatedData);
      setHybrid_AVG(
        (
          updatedData.reduce((sum, row) => sum + row.LMP, 0) /
          updatedData.length
        ).toFixed(2),
      );
    } else {
      setHybridRowData(Hybrid);
      setHybrid_AVG(
        (Hybrid.reduce((sum, row) => sum + row.LMP, 0) / Hybrid.length).toFixed(
          2,
        ),
      );
    }
  }, [Hybrid, DAClass]);

  useEffect(() => {
    if (useIndicative) {
      funcFilterCustom(false);
    } else {
      setCustom(mergeLMPByHourEnding(Hybrid, CustomModifiedRows, currentHE));
    }
  }, [useIndicative, Hybrid]);

  useEffect(() => {
    dateRef.current = flowDate.format("YYYY-MM-DD");
    funcFetchDALMP(true);
  }, [flowDate]);

  const Custom_RowData = useMemo(() => {
    if (!Custom || Custom.length === 0) return [];

    // Step 1: Apply DAHybrid for currentHE if needed
    let data = Custom.map((item) =>
      useDAHybrid && item.HourEnding == currentHE
        ? { ...item, LMP: DAHybrid }
        : item,
    );

    // Step 2: Filter based on DAClass
    if (DAClass === "OnPeak") {
      data = data.filter((row) => row.OnPeak);
    } else if (DAClass === "OffPeak") {
      data = data.filter((row) => !row.OnPeak);
    } else if (DAClass === "WePeak") {
      data = data.filter((row) => row.WePeak);
    }

    return data;
  }, [Custom, useDAHybrid, currentHE, DAHybrid, DAClass]);

  // Calculate average LMP for filtered data
  const Custom_AVG = useMemo(() => {
    if (!Custom_RowData || Custom_RowData.length === 0) return 0;

    const total = Custom_RowData.reduce(
      (sum, row) => sum + Number(row.LMP || 0),
      0,
    );
    return (total / Custom_RowData.length).toFixed(2);
  }, [Custom_RowData]);

  useEffect(() => {
    // --- First fetch (with true) ---

    funcFetchDALMP(true);

    // --- Set initial countdown ---
    setCountdown(15);

    const intervalId = setInterval(() => {
      // --- Update CST Time every second ---
      const nowCST = new Date().toLocaleTimeString("en-US", {
        timeZone: "America/Chicago",
        hour12: false,
      });
      setCurrentTime(nowCST);

      // --- Countdown + auto-fetch ---
      setCountdown((prev) => {
        if (prev === 1) {
          // Time to refresh (with false)
          funcFetchDALMP(false);
          return 15; // reset countdown
        }
        return prev - 1; // tick down
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    setCustom_ColumnDefs([
      {
        field: "LMP",
        headerName: "LMP",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HourEnding;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          }
        },
        editable: (params) => {
          const he = params.data.HourEnding;

          // Rule 1: Hybrid mode + current HE → disable
          if (useDAHybrid && he === currentHE) return false;

          // Rule 2: Disable for past hours
          if (he < currentHE) return false;

          // Otherwise editable
          return true;
        },
        cellEditor: "agNumberCellEditor",
        suppressKeyboardEvent: (params) => {
          const key = params.event.key;

          if (params.editing && (key === "ArrowUp" || key === "ArrowDown")) {
            // completely block editor from receiving arrow keys
            params.event.preventDefault();
            return true;
          }

          return false;
        },
        cellRenderer: (params) => {
          const value = params.value;
          const hourEnding = params.data.HourEnding;
          const showBoder = hourEnding >= Number(currentHE);

          return (
            <Box
              sx={{
                border: showBoder
                  ? theme.palette.mode === "dark"
                    ? "1px solid #ffffffbd"
                    : "1px solid #222222bd"
                  : "none",
                width: "100%",
              }}
            >
              {value}
            </Box>
          );
        },
      },
      {
        field: "Ticks",
        headerName: "Ticks",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HourEnding;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          }
        },
        cellRenderer: (params) => {
          const rtlmp = params.value;
          const row = params.data;
          const tableData = row.AdditionalData;
          return (
            <CustomTooltipCell
              tooltipContent={
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Interval</TableCell>
                        <TableCell>LMP</TableCell>
                        <TableCell>SCED</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.map((row, index) => {
                        const { Interval, IntervalLMP, ScedTimestamp } = row;
                        const rowCount = ScedTimestamp.length;

                        return ScedTimestamp.map(
                          (timestamp, timestampIndex) => (
                            <TableRow key={`${index}-${timestampIndex}`}>
                              {timestampIndex === 0 ? (
                                <>
                                  <TableCell rowSpan={rowCount}>
                                    {Interval}
                                  </TableCell>
                                  <TableCell rowSpan={rowCount}>
                                    {IntervalLMP}
                                  </TableCell>
                                </>
                              ) : null}
                              <TableCell>
                                {formatTimestamp(timestamp)}
                              </TableCell>
                            </TableRow>
                          ),
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              }
              value={<Box>{Math.round(rtlmp * 10) / 10}</Box>}
            />
          );
        },
      },
    ]);
    setHybrid_ColumnDefs([
      {
        field: "LMP",
        headerName: "LMP",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HourEnding;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          }
        },
      },
      {
        field: "Ticks",
        headerName: "Ticks",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HourEnding;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          }
        },
        cellRenderer: (params) => {
          const rtlmp = params.value;
          const row = params.data;

          const tableData = row.AdditionalData;
          const hourEnding = row.HourEnding;
          return (
            <CustomTooltipCell
              tooltipContent={
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Interval</TableCell>
                        <TableCell>LMP</TableCell>
                        <TableCell>SCED</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.map((row, index) => {
                        console.log(row);

                        const { Interval, IntervalLMP, ScedTimestamp } = row;
                        const rowCount = ScedTimestamp.length;

                        return ScedTimestamp.map(
                          (timestamp, timestampIndex) => (
                            <TableRow key={`${index}-${timestampIndex}`}>
                              {timestampIndex === 0 ? (
                                <>
                                  <TableCell rowSpan={rowCount}>
                                    {Interval}
                                  </TableCell>
                                  <TableCell rowSpan={rowCount}>
                                    {IntervalLMP}
                                  </TableCell>
                                </>
                              ) : null}
                              <TableCell>
                                {formatTimestamp(timestamp)}
                              </TableCell>
                            </TableRow>
                          ),
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              }
              value={
                <Box>
                  {Math.round(rtlmp * 10) / 10}{" "}
                  {hourEnding < Number(currentHE) ? "✓" : ""}
                </Box>
              }
            />
          );
        },
      },
    ]);
    setDALMP_ColumnDefs([
      {
        field: "HE",
        headerName: "HE",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HE;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          }
        },
      },
      {
        field: "LMP",
        headerName: "LMP",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HE;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "WePeak" ? "20px" : "16px",
            };
          }
        },
      },
    ]);
  }, [currentHE, theme, DAClass]);

  useEffect(() => {
    setIndicativePrices_CoulmnDefs([
      {
        field: "Interval",
        headerName: "Interval",
        flex: !isMobile && 1,
        width: isMobile && 115,
        cellStyle: (params) => ({
          fontSize: "16px",
        }),
      },
      {
        field: "SCED",
        headerName: "SCED",
        flex: !isMobile && 1,
        width: isMobile && 100,
        cellStyle: (params) => ({
          fontSize: "16px",
        }),
      },
      {
        field: "Indicative",
        headerName: "Indicative",
        flex: !isMobile && 1.125,
        width: isMobile && 125,
        cellStyle: (params) => {
          // Get the previous row value for the comparison
          const previousRow = params.api.getDisplayedRowAtIndex(
            params.rowIndex + 1,
          );
          const previousLMP = previousRow ? previousRow.data.Indicative : null;
          const currentLMP = params.value;

          // Compare current row value with previous row's value for LMP
          if (previousLMP !== null) {
            // Convert to numbers to ensure we are comparing numbers, not strings
            const currentLMPNum = Number(currentLMP);
            const previousLMPNum = Number(previousLMP);

            // Check if both values are valid numbers before proceeding
            if (!isNaN(currentLMPNum) && !isNaN(previousLMPNum)) {
              if (currentLMPNum < previousLMPNum) {
                return {
                  fontSize: "16px",
                  color: "#FF0000",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "#2a2a2a",
                }; // If current < previous, color red
              } else if (currentLMPNum > previousLMPNum) {
                return {
                  fontSize: "16px",
                  color: "#30bf35",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "#2a2a2a",
                }; // If current > previous, color green
              }
            }
          }

          return { fontSize: "14px" }; // No style if no previous value to compare
        },
      },
      {
        field: "Prev01",
        headerName: "Prev01",
        flex: !isMobile && 1,
        width: isMobile && 120,
        cellStyle: (params) => {
          // Get the previous row value for the comparison
          const previousRow = params.api.getDisplayedRowAtIndex(
            params.rowIndex + 1,
          );
          const previousLMP = previousRow ? previousRow.data.Prev01 : null;
          const currentLMP = params.value;

          // Compare current row value with previous row's value for LMP
          if (previousLMP !== null) {
            // Convert to numbers to ensure we are comparing numbers, not strings
            const currentLMPNum = Number(currentLMP);
            const previousLMPNum = Number(previousLMP);

            // Check if both values are valid numbers before proceeding
            if (!isNaN(currentLMPNum) && !isNaN(previousLMPNum)) {
              if (currentLMPNum < previousLMPNum) {
                return {
                  fontSize: "16px",
                  color: "#FF0000",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "#2a2a2a",
                }; // If current < previous, color red
              } else if (currentLMPNum > previousLMPNum) {
                return {
                  fontSize: "16px",
                  color: "#30bf35",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "#2a2a2a",
                }; // If current > previous, color green
              }
            }
          }

          return {}; // No style if no previous value to compare
        },
      },
      {
        field: "Prev02",
        headerName: "Prev02",
        flex: !isMobile && 1,
        width: isMobile && 120,
        cellStyle: (params) => {
          // Get the previous row value for the comparison
          const previousRow = params.api.getDisplayedRowAtIndex(
            params.rowIndex + 1,
          );
          const previousLMP = previousRow ? previousRow.data.Prev02 : null;
          const currentLMP = params.value;

          // Compare current row value with previous row's value for LMP
          if (previousLMP !== null) {
            // Convert to numbers to ensure we are comparing numbers, not strings
            const currentLMPNum = Number(currentLMP);
            const previousLMPNum = Number(previousLMP);

            // Check if both values are valid numbers before proceeding
            if (!isNaN(currentLMPNum) && !isNaN(previousLMPNum)) {
              if (currentLMPNum < previousLMPNum) {
                return {
                  fontSize: "16px",
                  color: "#FF0000",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "#2a2a2a",
                }; // If current < previous, color red
              } else if (currentLMPNum > previousLMPNum) {
                return {
                  fontSize: "16px",
                  color: "#30bf35",
                  backgroundColor:
                    theme.palette.mode === "light" ? "#fff" : "#2a2a2a",
                }; // If current > previous, color green
              }
            }
          }

          return {}; // No style if no previous value to compare
        },
      },
    ]);
  }, [theme]);

  const handleCellValueChanged = (params) => {
    const { oldValue, newValue, colDef, node } = params;

    // Check if the column changed is "LMP"
    if (colDef.field === "LMP") {
      console.log("Old Value:", oldValue);
      console.log("New Value:", newValue);

      // Find the row being updated using HourEnding as the unique key
      const updatedRowData = Custom.map((row) => {
        if (row.HourEnding === node.data.HourEnding) {
          // Update the LMP field for the row with matching HourEnding
          return { ...row, LMP: newValue };
        }
        return row;
      });
      setCustomModifiedRows(JSON.parse(JSON.stringify(updatedRowData)));
      // Update state with the new row data
      setCustom(updatedRowData);
    }
  };

  const onCellKeyDown = useCallback((params) => {
    const event = params.event;
    const key = event.key;

    if (key !== "ArrowUp" && key !== "ArrowDown") return;

    // only for editable column
    if (!params.column.getColDef().editable) return;

    const api = params.api;
    const column = params.column;
    const rowIndex = params.node.rowIndex;

    event.preventDefault();
    event.stopPropagation();

    // stop editing current cell
    api.stopEditing();

    let nextRowIndex = key === "ArrowDown" ? rowIndex + 1 : rowIndex - 1;

    if (nextRowIndex < 0 || nextRowIndex >= api.getDisplayedRowCount()) {
      return;
    }

    // focus next cell
    api.setFocusedCell(nextRowIndex, column);

    // start editing after focus is applied
    setTimeout(() => {
      api.startEditingCell({
        rowIndex: nextRowIndex,
        colKey: column.getColId(),
      });
    }, 0);
  }, []);

  const onCellFocused = (params) => {
    if (!params.column) return;

    const colDef = params.column.getColDef();
    if (!colDef.editable) return;

    // delay editing until grid finishes focus cycle
    requestAnimationFrame(() => {
      params.api.startEditingCell({
        rowIndex: params.rowIndex,
        colKey: params.column.getColId(),
      });
    });
  };
  const resetCustom = () => {
    setCustomModifiedRows([]);
    funcModifyCustom(false);
  };

  return (
    <Stack>
      <BackgroundContainer>
        {/* Right section */}
        {isMobile ? (
          <Stack
            spacing={3}
            sx={{
              px: 3,
              py: 2,
              justifyContent: "flex-start",
              display: "flex",
              backgroundColor: theme.palette.customColors.lightBackground,
            }}
          >
            {/* First Row: Class and Date Selector */}
            <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
              <Stack sx={{ width: "50%" }}>
                <Typography sx={{ fontSize: "14px" }}>Class:</Typography>
                <Select
                  value={DAClass}
                  onChange={(e) => setDAClass(e.target.value)}
                  size="small"
                  sx={{ width: "100%" }}
                >
                  <MenuItem value="OnPeak">ONPEAK</MenuItem>
                  <MenuItem value="OffPeak">OFFPEAK</MenuItem>
                  <MenuItem value="WePeak">WEPEAK</MenuItem>
                  <MenuItem value="ATC">ATC</MenuItem>
                </Select>
              </Stack>
              <Stack sx={{ width: "50%" }}>
                <Typography sx={{ fontSize: "14px" }}>
                  Choose a date:
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <FormControl fullWidth>
                    <Stack direction="column" spacing={0.25}>
                      <DesktopDatePicker
                        value={flowDate}
                        onChange={(date) => setflowDate(dayjs(date))}
                        views={["year", "month", "day"]}
                        openTo="day"
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </Stack>
                  </FormControl>
                </LocalizationProvider>
              </Stack>
            </Stack>

            {/* Second Row: Frequency and Dispatch */}
            <Stack direction="row" spacing={3} justifyContent={"space-between"}>
              <Stack>
                <Typography sx={{ fontSize: "14px" }}>Frequency:</Typography>
                <Typography sx={{ fontSize: "20px", display: "flex" }}>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      color: ERCOTFrequencyDelta > 0 ? "green" : "red",
                    }}
                  >
                    {ERCOTFrequency}
                  </Typography>
                  ({ERCOTFrequencyDelta})
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  @{LatestFrequencyTimestamp} CST
                </Typography>
              </Stack>
              <Stack>
                <Typography sx={{ fontSize: "14px" }}>Dispatch:</Typography>
                <Typography sx={{ fontSize: "14px", display: "flex" }}>
                  {LatestFrequencyTimestamp} CST ({countdown})
                </Typography>
              </Stack>
            </Stack>

            {/* Third Row: Checkboxes and Current HE & DAHybrid */}
            <Stack direction="row" spacing={3} justifyContent={"space-between"}>
              <Stack>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={useDAHybrid}
                      onChange={(e) => setuseDAHybrid(e.target.checked)}
                    />
                  }
                  label="Use DAHybrid"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={useIndicative}
                      onChange={(e) => setuseIndicative(e.target.checked)}
                    />
                  }
                  label="Use Indicative"
                />
              </Stack>
              <Stack>
                <Typography sx={{ fontSize: "14px" }}>
                  Hour Ending: {currentHE}
                </Typography>
                <Typography sx={{ fontSize: "14px", display: "flex" }}>
                  DA Hybrid: {DAHybrid}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        ) : (
          <Box
            sx={{
              px: 30, // ✅ SAME AS REFERENCE
              py: 1.5,
              display: "grid",
              gridTemplateColumns: `
      120px
      300px
      160px
      240px
      180px
      170px
      180px
    `,
              columnGap: 3,
              alignItems: "start",
              backgroundColor: theme.palette.customColors.lightBackground,
            }}
          >
            {/* CLASS */}
            <Box>
              <Typography fontSize={14}>Class:</Typography>
              <Select
                value={DAClass}
                onChange={(e) => setDAClass(e.target.value)}
                size="small"
                sx={{ width: 100 }}
              >
                <MenuItem value="OnPeak">ONPEAK</MenuItem>
                <MenuItem value="OffPeak">OFFPEAK</MenuItem>
                <MenuItem value="WePeak">WEPEAK</MenuItem>
                <MenuItem value="ATC">ATC</MenuItem>
              </Select>
            </Box>

            {/* FREQUENCY (ACE SLOT) */}
            <Box>
              <Typography fontSize={14}>Frequency:</Typography>
              <Typography
                fontSize={20} // ✅ SAME AS REFERENCE
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <strong
                  style={{
                    color: ERCOTFrequencyDelta > 0 ? "green" : "red",
                  }}
                >
                  {ERCOTFrequency}
                </strong>{" "}
                ({ERCOTFrequencyDelta}) @{LatestFrequencyTimestamp} CST
              </Typography>
            </Box>

            {/* CURRENT TIME */}
            <Box>
              <Typography fontSize={14}>Current Time:</Typography>
              <Typography fontSize={16} whiteSpace="nowrap">
                {CurrentTime} CST
              </Typography>
            </Box>

            {/* DISPATCH */}
            <Box>
              <Typography fontSize={14}>Dispatch:</Typography>
              <Typography fontSize={16} whiteSpace="nowrap">
                {LatestFrequencyTimestamp} CST ({countdown})
              </Typography>
            </Box>

            {/* CHECKBOXES */}
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={useDAHybrid}
                    onChange={(e) => setuseDAHybrid(e.target.checked)}
                  />
                }
                label="Use DAHybrid"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={useIndicative}
                    onChange={(e) => setuseIndicative(e.target.checked)}
                  />
                }
                label="Use Indicative"
              />
            </Box>

            {/* HE / HYBRID */}
            <Box>
              <Typography fontSize={14} whiteSpace="nowrap">
                Hour Ending: {currentHE}
              </Typography>
              <Typography fontSize={16} whiteSpace="nowrap">
                DA Hybrid: {DAHybrid}
              </Typography>
            </Box>

            {/* DATE PICKER */}
            <Box>
              <CustomDatePicker
                mode="single"
                label="Choose a date:"
                value={flowDate}
                onChange={(date) => {setflowDate(dayjs(date));}}
              />
            </Box>
          </Box>
        )}
      </BackgroundContainer>
      <Stack sx={{ padding: 2, px: 5 }}>
        <Stack direction={isMobile ? "column" : "row"} spacing={3}>
          {/* Day-Ahead Column */}
          <Stack
            sx={{
              padding: 0,
              borderRadius: 2,
              py: 2,
              display: "flex",
              flex: 1.2,
              minWidth: 0,
              width: isMobile && "100%",
              px: 1,
              border:
                theme.palette.mode === "dark"
                  ? "1px solid #ffffffbd"
                  : "1px solid #222222bd",
            }}
            spacing={1}
          >
            <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
              Day-Ahead
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {isValidNumber(DALMP_AVG) && (
                <Typography sx={{ textAlign: "center", fontSize: "30px" }}>
                  {DALMP_AVG}
                </Typography>
              )}
            </Stack>
            <Stack
              sx={{
                overflowX: "hidden !important",
              }}
            >
              <CommonAgGrid
                rowData={DayAheadRowData}
                columnDefs={DALMP_ColumnDefs}
                className="custom-grid-theme"
                domLayout="autoHeight"
                defaultColumnDefs={{ filter: true }}
                headerHeight={30}
                rowHeight={
                  DAClass === "OnPeak" || DAClass === "WePeak" ? 40 : 30
                }
              />
            </Stack>
          </Stack>

          {/* Hybrid Column */}
          <Stack
            sx={{
              padding: 0,
              borderRadius: 2,
              py: 2,
              display: "flex",
              flex: 1.2,
              minWidth: 0,
              width: isMobile && "100%",
              px: 1,
              border:
                theme.palette.mode === "dark"
                  ? "1px solid #ffffffbd"
                  : "1px solid #222222bd",
            }}
            spacing={1}
          >
            <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
              Hybrid
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {isValidNumber(Hybrid_AVG) && (
                <Typography sx={{ textAlign: "center", fontSize: "30px" }}>
                  {Hybrid_AVG}
                </Typography>
              )}
            </Stack>
            <Stack
              sx={{
                overflowX: "hidden !important",
              }}
              spacing={2}
            >
              <CommonAgGrid
                rowData={HybridRowData}
                columnDefs={Hybrid_ColumnDefs}
                className="custom-grid-theme"
                defaultColumnDefs={{ filter: true }}
                headerHeight={30}
                rowHeight={
                  DAClass === "OnPeak" || DAClass === "WePeak" ? 40 : 30
                }
                domLayout="autoHeight"
              />
              <Typography>
                ✓ Indicates all Settlement Prices for the hour are present
              </Typography>
            </Stack>
          </Stack>

          {/* Custom Column */}
          <Stack
            sx={{
              padding: 0,
              borderRadius: 2,
              py: 2,
              display: "flex",
              flex: 1.2,
              minWidth: 0,
              width: isMobile && "100%",
              px: 1,
              border:
                theme.palette.mode === "dark"
                  ? "1px solid #ffffffbd"
                  : "1px solid #222222bd",
            }}
            spacing={0.5}
          >
            <Stack
              direction="row"
              spacing={0}
              justifyContent="center"
              alignItems="center"
            >
              <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
                Custom
              </Typography>
              <IconButton onClick={resetCustom}>
                <Tooltip title="Reset Custom">
                  <RestoreIcon sx={{ fontSize: "30px" }} />
                </Tooltip>
              </IconButton>
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography sx={{ textAlign: "center", fontSize: "30px" }}>
                {Custom_AVG ? Custom_AVG : ""}
              </Typography>
            </Stack>
            <Stack
              sx={{
                overflowX: "hidden !important",
              }}
              spacing={2}
            >
              <CommonAgGrid
                rowData={Custom_RowData}
                columnDefs={Custom_ColumnDefs}
                className="custom-grid-theme"
                domLayout="autoHeight"
                defaultColumnDefs={{ filter: true }}
                headerHeight={30}
                rowHeight={
                  DAClass === "OnPeak" || DAClass === "WePeak" ? 40 : 30
                }
                onCellValueChanged={handleCellValueChanged}
                onCellKeyDown={onCellKeyDown}
                onCellFocused={onCellFocused}
              />
              <Typography>
                Prices are calculated using RT LMP, Dispatch, and DA LMPs.
              </Typography>
            </Stack>
          </Stack>

          {/* SCED Column */}
          <Stack
            sx={{
              padding: 0,
              borderRadius: 2,
              py: 2,
              display: "flex",
              flex: 2,
              minWidth: 0,
              width: isMobile && "100%",
              px: 1,
              border:
                theme.palette.mode === "dark"
                  ? "1px solid #ffffffbd"
                  : "1px solid #222222bd",
            }}
            spacing={1}
          >
            <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
              SCED
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography sx={{ textAlign: "center", fontSize: "30px" }}>
                {SCEDAvg ? Math.round(SCEDAvg * 100) / 100 : 0}
              </Typography>
            </Stack>
            <Stack
              sx={{
                height: "75vh",
                overflowX: "hidden !important",
              }}
              spacing={2}
            >
              <CommonAgGrid
                rowData={SCEDData}
                columnDefs={SCED_ColumnDefs}
                className="custom-grid-theme"
                defaultColumnDefs={{ filter: true }}
                pagination={true}
                paginationPageSize={20}
                headerHeight={30}
                rowHeight={30}
                paginationPageSizeSelector={false}
              />
              <Typography>Times are actual timestamps CPT</Typography>
            </Stack>
          </Stack>

          {/* Dispatch Column */}
          <Stack
            sx={{
              padding: 0,
              borderRadius: 2,
              py: 2,
              display: "flex",
              flex: 3.3,
              minWidth: 0,
              width: isMobile && "100%",
              px: 1,
              border:
                theme.palette.mode === "dark"
                  ? "1px solid #ffffffbd"
                  : "1px solid #222222bd",
            }}
            spacing={2}
          >
            <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
              Indicative
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography sx={{ textAlign: "center", fontSize: "20px" }}>
                {LatestIndicativeTimestamp}
              </Typography>
            </Stack>
            <Stack
              sx={{
                height: "75vh",
                overflowX: "hidden !important",
              }}
              spacing={2}
            >
              <CommonAgGrid
                rowData={IndicativePrices}
                columnDefs={IndicativePrices_ColumnDefs}
                className="custom-grid-theme"
                defaultColumnDefs={{ filter: true }}
                pagination={true}
                headerHeight={30}
                rowHeight={30}
                paginationPageSize={20}
                paginationPageSizeSelector={false}
              />
              <Typography>Times are interval ending CPT</Typography>
            </Stack>
          </Stack>
        </Stack>

        <Stack>
          <Stack direction={"row"} spacing={3} sx={{ padding: 2 }}>
            <Typography sx={{ fontWeight: 600 }}>
              Hourly RUC Online in SCED Offline in COP Report:{" "}
              {LatestRucMarketDay}
            </Typography>
          </Stack>
          <Stack sx={{ height: isMobile ? "100px" : "80px" }}>
            <CommonAgGrid
              rowData={ERCOTRucData}
              columnDefs={Ruc_ColumnDefs}
              className="custom-grid-theme"
              defaultColumnDefs={{
                filter: true,
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ERCOT;
